import { Component, inject, Input } from '@angular/core';
import { EcouponServiceService } from '../core/service/ecoupon-service.service';
import { tap } from 'rxjs';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-loading',
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  router = inject(Router);
  private readonly ecouponService = inject(EcouponServiceService);
  private readonly loggingService = inject(LoggingService);

  errStatus = this.ecouponService.getErrorStatusSignal();

  constructor() {
    this.ecouponService.clearDataFormSignal();
    this.ecouponService.clearErrorMessageSignal();
    this.ecouponService.clearErroStatusSignal();
  }
  @Input() set id(item: string) {
    // this.nameRoute.set(item);
    this.loggingService.log('this.errStatus', this.errStatus());

    this.ecouponService
      .getDetailCampaign(item)
      .pipe(
        tap((res: any) => {
          if (res.data) {
            // this.detail = res.data;
            this.loggingService.log('getDetailCampaign', res);
            this.loggingService.log('getDetailCampaign', this.errStatus());
          }
          this.loggingService.log('this.errStatus', this.errStatus());
          if (this.errStatus() !== 10) {
            this.routeToInfomation('');
          } else {
            this.router.navigateByUrl('e-coupon/campaign/form/' + item);
          }
        })
      )
      .subscribe();
    // this.ecouponService
    //   .getCheckCampaignExpire(item)
    //   .pipe(
    //     tap((res: any) => {
    //       if (res.data) {
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //         // // status 10 = coupon can use
    //         if (this.errStatus() !== 10) {
    //           this.routeToInfomation('');
    //         }
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //       }
    //     })
    //   )
    //   .subscribe();
    // this.ecouponService
    //   .getCheckCampaignFull(item)
    //   .pipe(
    //     tap((res: any) => {
    //       if (res.data) {
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //         if (this.errStatus() !== 10) {
    //           this.routeToInfomation('');
    //         } else {
    //           this.router.navigateByUrl('e-coupon/campaign/form/' + item);
    //         }
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //       }
    //     })
    //   )
    //   .subscribe();
  }
  routeToInfomation(path: string) {
    this.router.navigateByUrl('e-coupon/information');
  }
}
